export default __webpack_public_path__ + "static/media/greeting7.720cd1e5.svg";